<template>
  <div class="container">
    <BackBar color="#295661" />
    <div v-if="informe" class="informe-detalhe">
      <h2>{{ informe.title }}</h2>
      <p class="section-label">{{ informe.subtitle }}</p>
      <p class="updated-at">{{ formattedDate }}</p>
      <img :src="informe.urlImage" :alt="informe.title" class="informe-img" />
      <!-- Alteração: Renderizar o conteúdo processado -->
      <div class="description" v-html="processedContent"></div>
    </div>
    <div v-else>
      <p>Carregando...</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import BackBar from "../layouts/BackBar.vue";
import { fetchInformes } from "../../services/informesService";
const MarkdownIt = require("markdown-it/dist/markdown-it.js"); // Garantir uso da versão CommonJS

export default {
  name: "InformeDetalhe",
  components: {
    BackBar
  },
  data() {
    return {
      informe: null,
      formattedDate: "",
      processedContent: "" // Adicionado para armazenar o conteúdo processado
    };
  },
  async mounted() {
    const { id } = this.$route.params;
    await this.fetchInforme(id);
  },
  methods: {
    async fetchInforme(id) {
      try {
        const data = await fetchInformes();
        this.informe = data.find(informe => informe.id === parseInt(id));
        if (this.informe) {
          this.formatDate(this.informe.updatedAt);
          this.processContent(this.informe.content); // Processar o conteúdo
        } else {
          console.error("Informe não encontrado.");
        }
      } catch (error) {
        console.error("Erro ao buscar os informes:", error);
      }
    },
    formatDate(updatedAt) {
      const [date, time] = updatedAt.split(" ");
      const [day, month, year] = date.split("/");
      const [hour, minute] = time.split(":");
      const updatedDate = new Date(
        `${year}-${month}-${day}T${hour}:${minute}:00`
      );
      const now = new Date();
      const diffInSeconds = Math.floor((now - updatedDate) / 1000);

      const rtf = new Intl.RelativeTimeFormat("pt-BR", { numeric: "auto" });
      let timeAgo = "";

      if (diffInSeconds < 60) {
        timeAgo = rtf.format(-diffInSeconds, "second");
      } else if (diffInSeconds < 3600) {
        timeAgo = rtf.format(-Math.floor(diffInSeconds / 60), "minute");
      } else if (diffInSeconds < 86400) {
        timeAgo = rtf.format(-Math.floor(diffInSeconds / 3600), "hour");
      } else if (diffInSeconds < 2592000) {
        timeAgo = rtf.format(-Math.floor(diffInSeconds / 86400), "day");
      } else if (diffInSeconds < 31536000) {
        timeAgo = rtf.format(-Math.floor(diffInSeconds / 2592000), "month");
      } else {
        timeAgo = rtf.format(-Math.floor(diffInSeconds / 31536000), "year");
      }

      const formattedTime = `${hour}h${minute}`;
      this.formattedDate = `${day}/${month}/${year} ${formattedTime} Atualizado ${timeAgo}`;
    },
    processContent(content) {
      // Processar o conteúdo com markdown-it para HTML
      const md = new MarkdownIt();
      this.processedContent = md.render(content);
    }
  }
};
</script>

<style scoped>
.container {
  font-family: "Nunito", sans-serif;
  padding: 20px;
}

.informe-detalhe h2 {
  font-size: 24px;
  font-weight: bold;
  color: #295661;
  margin-bottom: 10px;
}

.section-label {
  font-size: 20px;
  color: #898989;
  font-weight: 600;
  margin-bottom: 15px;
}

.updated-at {
  font-size: 12px;
  color: #414141;
  margin-bottom: 6px;
}

.informe-img {
  width: 100%;
  height: auto;
  margin: 20px 0;
  border-radius: 10px;
}

.description {
  font-size: 16px;
  color: #3f3f3f;
  line-height: 1.5;
}
</style>
